import { lazy } from 'react';

const WebcamPhotoModal = lazy(() => import('./modals/WebcamPhotoModal'));

export default {
  WEBCAM_PHOTO_MODAL: WebcamPhotoModal,
};
